// A product's `videos` list mixes uploaded files (served from /media) with
// YouTube/Vimeo links. These helpers decide how each entry should be rendered.

const YOUTUBE = /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/i;
const VIMEO = /vimeo\.com\/(?:video\/)?(\d+)/i;

export const isExternal = (url) => /^https?:\/\//i.test(url || "");

/**
 * Return an embeddable player URL for a YouTube or Vimeo link, or null when the
 * entry is not a recognised external video (an uploaded file, for instance).
 */
export const embedUrl = (url) => {
  if (!isExternal(url)) return null;

  const youtube = url.match(YOUTUBE);
  if (youtube) return `https://www.youtube-nocookie.com/embed/${youtube[1]}`;

  const vimeo = url.match(VIMEO);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;

  return null;
};

/** True when the entry should be played with a native <video> tag. */
export const isPlayableFile = (url) => !!url && !embedUrl(url);

export const isSupportedVideoLink = (url) => !!embedUrl(url);
